module.exports = __webpack_public_path__ + "img/m.b2974582.svg";